import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add meta tags for performance
const metaViewport = document.createElement('meta');
metaViewport.name = 'viewport';
metaViewport.content = 'width=device-width, initial-scale=1';
document.head.appendChild(metaViewport);
const metaThemeColor = document.createElement('meta');
metaThemeColor.name = 'theme-color';
metaThemeColor.content = '#1a1a1a';
document.head.appendChild(metaThemeColor);
render(<App data-id="element-296" />, document.getElementById('root'));